<template>
  <v-dialog persistent v-model="value" max-width="290">
    <v-form @submit.prevent="save">
      <v-card>
        <v-card-title class="headline">{{ edit? $t('Pages.WorkplaceGroupationRules.update') : $t('Pages.WorkplaceGroupationRules.add_new') }}</v-card-title>

        <v-card-text>
          <v-layout column wrap>
            <v-flex>
              <v-autocomplete
                v-model="newWorkplaceGroupationRule.groupation_id"
                :items="groupations"
                v-validate="'required'"
                :error-messages="errors.first('groupations')"
                name="groupations"
                color="indigo"
                hide-no-data
                hide-selected
                item-text="name"
                item-value="id"
                :label="$t('Pages.Groupations.title_singular')"
                :placeholder="$t('Common.type_to_search')"
                prepend-icon="mdi-account-multiple"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-autocomplete
                v-model="newWorkplaceGroupationRule.warehouse_id"
                :items="warehouses"
                v-validate="'required'"
                :error-messages="errors.first('warehouses')"
                name="warehouses"
                color="indigo"
                hide-no-data
                hide-selected
                item-text="name"
                item-value="id"
                :label="$t('Pages.Warehouses.title_singular')"
                :placeholder="$t('Common.type_to_search')"
                prepend-icon="home_work"
              ></v-autocomplete>
            </v-flex>
            <v-flex>
              <v-text-field
                v-validate="'required|min_value:0'"
                v-model="months"
                :error-messages="errors.first('months')"
                :label="$t('Pages.WorkplaceGroupationRules.model.months')"
                type="number"
                color="indigo"
                name="months"
                min="0"
                @input="days = 0, hours = 0"
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-validate="'required|min_value:0'"
                v-model="days"
                :error-messages="errors.first('days')"
                :label="$t('Pages.WorkplaceGroupationRules.model.days')"
                type="number"
                color="indigo"
                name="days"
                min="0"
                @input="months = 0, hours = 0"
              />
            </v-flex>
            <v-flex>
              <v-text-field
                v-validate="'required|min_value:0'"
                v-model="hours"
                :error-messages="errors.first('hours')"
                :label="$t('Pages.WorkplaceGroupationRules.model.hours')"
                type="number"
                color="indigo"
                name="hours"
                min="0"
                @input="days = 0, months = 0"
              />
            </v-flex>
            <v-flex>
              <v-switch
                v-validate="'required'"
                v-model="newWorkplaceGroupationRule.email_notification"
                :error-messages="errors.first('order')"
                :label="$t('Pages.WorkplaceGroupationRules.model.email')"
                color="indigo"
                name="email"
                class="justify-center"
              />
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn @click="close">
                {{$t('Core.Fields.close')}}
            </v-btn>

            <v-btn dark color="success dark1" type="submit">
                {{$t('Core.Fields.save')}}
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import _ from 'lodash';
  export default {
  components: {},
  props: ['workplaceGroupationRule', 'value', 'pagination', 'edit', 'groupations', 'warehouses'],
  data: () => ({
    newWorkplaceGroupationRule: {},
    months: 0,
    days: 0,
    hours: 8
  }),
  computed: {
  },
  created () {
  },
  methods: {
    close(){
      this.$emit('close')
      this.newWorkplaceGroupationRule = {}
      this.$validator.reset()
      this.months = 0
      this.days = 0
      this.hours = 8
    },
    save(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.months != 0 && this.days == 0 && this.hours == 0) {
            this.newWorkplaceGroupationRule.expiration = this.months * 30 * 24
          } 
          
          if(this.months == 0 && this.days != 0 && this.hours == 0) {
            this.newWorkplaceGroupationRule.expiration = this.days * 24
          } 
          
          if(this.months == 0 && this.days == 0 && this.hours != 0) {
            this.newWorkplaceGroupationRule.expiration = this.hours
          }

          this.newWorkplaceGroupationRule.workplace_id = this.$route.params.id

          if(this.edit) {
            this.repositories.workplaceGroupationRule.update(this.newWorkplaceGroupationRule.id, this.newWorkplaceGroupationRule).then((response) => {
              this.$toast.success(response.data.message);
              this.$emit('refreshGroupationRule');
              this.close()
            });
          } else {
            this.repositories.workplaceGroupationRule.store(this.newWorkplaceGroupationRule).then((response) => {
              this.$toast.success(response.data.message);
              this.$emit('refreshGroupationRule');
              this.close()
            });
          }

        }
      });
    }
  },
  watch: {
    value: function() {
      if(!this.edit && this.value) {
        this.newWorkplaceGroupationRule.email_notification = false
      } else if(this.value) {
        this.newWorkplaceGroupationRule = JSON.parse(JSON.stringify(this.workplaceGroupationRule));
        this.newWorkplaceGroupationRule.groupation_id = this.newWorkplaceGroupationRule.groupation.id;
        this.newWorkplaceGroupationRule.warehouse_id = this.newWorkplaceGroupationRule.warehouse.id;
        this.hours = 0
        if(this.workplaceGroupationRule.expiration > 719) {
          this.months = this.workplaceGroupationRule.expiration / 30 / 24
        } else if(this.workplaceGroupationRule.expiration > 23) {
          this.days = this.workplaceGroupationRule.expiration / 24
        } else {
          this.hours = this.workplaceGroupationRule.expiration
        }
      }
    }
  }
}
</script>

<style lang="scss">

</style>